<script setup>
import { computed } from 'vue'

import DateSelector from '@/components/shared/DateSelector.vue'
import dayjs from 'dayjs'
import { useReadonlyField } from '@/composables/readonly-form'

const props = defineProps({
  modelValue: {
    type: [Object, String, null],
    required: true,
  },
  availableDates: {
    type: Array,
    required: false,
  },
  label: {
    type: String,
    required: true,
  },
  end: {
    type: Boolean,
    required: false,
  },
  min: {
    type: String,
    required: false,
  },
  max: {
    type: String,
    required: false,
  },
  range: {
    type: Boolean,
    required: false,
    default: true,
  },
  clearable: {
    type: Boolean,
    required: false,
    default: false,
  },
  rules: {
    type: Array,
    required: false,
  },
  readonly: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const isReadonly = useReadonlyField(() => props.readonly)

const emit = defineEmits(['update:modelValue'])

const availableDates = computed(() => {
  if (props.availableDates) {
    return props.availableDates
  }

  if (props.min && props.max) {
    return (dateValue) => {
      return dayjs(dateValue).isSameOrAfter(dayjs(props.min), 'day') && dayjs(dateValue).isSameOrBefore(dayjs(props.max), 'day')
    }
  }

  if (props.min) {
    return (dateValue) => {
      return dayjs(dateValue).isSameOrAfter(dayjs(props.min), 'day')
    }
  }
  if (props.max) {
    return (dateValue) => {
      return dayjs(dateValue).isSameOrBefore(dayjs(props.max), 'day')
    }
  }
  return undefined
})

</script>
<template>
  <q-input
    :model-value="props.end ? props.modelValue.end : props.modelValue?.start || props.modelValue"
    mask="date"
    :clearable="props.clearable && !isReadonly"
    :label="label"
    :readonly="isReadonly"
    :rules="props.rules"
    @clear="emit('update:modelValue', null)"
  >
    <template #append>
      <q-icon
        name="mdi-calendar"
        :class="{ 'cursor-pointer': !isReadonly }"
      >
        <q-popup-proxy
          v-if="!isReadonly"
          cover
          :maximized="false"
          transition-show="scale"
          transition-hide="scale"
        >
          <date-selector
            :model-value="props.modelValue"
            :label="label"
            :end="props.end"
            :available-dates="availableDates"
            close-button
            :range="props.range"
            :min="props.min"
            :max="props.max"
            @update:model-value="emit('update:modelValue', $event)"
          />
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-input>
</template>
